import React, {useState} from 'react';
import ImageCardWithDetails from '../../doc-explorer/doc-list-grid-view/ImageCardWithDetails';

export type ComboPanelMetadata = {
  docId: string;
  custodianName: string;
  docFileName: string;
  docFileType: string;
  masterDate: string;
  imgUrl: string;
};

const metadataList: ComboPanelMetadata[] = [
  {
    docId: 'ID00000004',
    custodianName: 'Bill Pullman',
    docFileName: 'GoneToPlaid',
    docFileType: '.JPG',
    masterDate: '1987/06/24 13:00:00',
    imgUrl: '',
  },
  {
    docId: 'ID00000005',
    custodianName: 'Lone Starr',
    docFileName: 'Spaceballs',
    docFileType: '.PDF',
    masterDate: '1987/06/25 14:00:00',
    imgUrl: '',
  },
  // Add more entries here
];

const IconButton: React.FC = () => {
  const [selectedMap, setSelectedMap] = useState<Record<string, boolean>>({});

  const handleSelect = (docId: string, checked: boolean) => {
    setSelectedMap((prev) => ({
      ...prev,
      [docId]: checked,
    }));
  };

  return (
    <>
      {metadataList.map(({imgUrl, ...rest}) => (
        <ImageCardWithDetails
          key={rest.docId}
          metadata={rest}
          imageUrl={imgUrl}
          isSelected={!!selectedMap[rest.docId]}
          onSelect={(checked) => handleSelect(rest.docId, checked)}
        />
      ))}
    </>
  );
};

export default IconButton;
